<template>
  <div class="userForm">
    <el-dialog
        :visible="visible"
        width="40%"
        @close="cancel"
        :title="openType === 'add' ? '新增会员等级' : '编辑会员等级'"
        custom-class="customModal">
        <AppForm
          v-if="visible"
          cancenlMargin
          ref="form"
          formStyle="default"
          :fields="formFields"
          :rules="rules"
          :defaultValues="defaultValues"
          @cancel="cancel"
          @submit="submit"/>
      </el-dialog>
  </div>
</template>

<script>
import { VipGradeService } from '../../service/vipGrade.service';
  export default {
    name: 'formVipGrade',
    data() {
      return {
        openType: 'add',
        visible: false,
        defaultValues: {},
        rules: {
          amount: [{ required: true, message: '消费额度不能为空'}],
          discount: [{ required: true, message: '折扣率不能为空'}],
          describe: [{ required: true, message: '等级描述不能为空'}],
          level_name: [{ required: true, message: '等级名称不能为空'}],
        },
        formFields: [
          { type: 'number', key: 'amount', label: '消费额度', span: 12 },
          { type: 'number', key: 'discount', label: '折扣率', max: 100, min: 1, span: 12 },
          { type: 'input', key: 'level_name', label: '等级名称', span: 12 },
          { type: 'textarea', key: 'describe', label: '等级描述', span: 24 },
        ]
      }
    },
    methods: {
      open(openType, data) {
        this.openType = openType;
        if (openType === 'edit') {
          const defaultValues = JSON.parse(JSON.stringify(data));
          defaultValues.amount = Number(defaultValues.amount);
          this.defaultValues = defaultValues;
        } else {
          this.defaultValues = {};
        }
        this.visible = true;
      },
      cancel() {
        this.defaultValues = null;
        this.visible = false;
      },
      async submit(data) {
        if (data.level_id) {
          await VipGradeService.operate('edit', data);
        } else {
          await VipGradeService.operate('add', data);
        }
        this.$emit('success');
        this.cancel();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>